import React from 'react';
import styled from 'styled-components';

interface FooterProps {
  onBooksClick?: () => void;
  onVideoLearningClick?: () => void;
  onBlogsClick?: () => void;
  onMkAcademyOnlineClick?: () => void;
  onFaqClick?: () => void;
  onFeedbackClick?: () => void;
}

const FooterSection = styled.footer`
  background: #1e293b;
  color: white;
  padding: 3rem 0 1rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
`;

const FooterColumn = styled.div`
  h3 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #fbbf24;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: #cbd5e1;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #fbbf24;
    }
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid #334155;
  padding-top: 1rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.9rem;
`;

const Footer: React.FC<FooterProps> = ({ 
  onBooksClick, 
  onVideoLearningClick, 
  onBlogsClick, 
  onMkAcademyOnlineClick,
  onFaqClick,
  onFeedbackClick 
}) => {
  return (
    <FooterSection>
      <Container>
        <FooterContent>
          <FooterColumn>
            <h3>MathKnots</h3>
            <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
              360 degree learning – making learning smarter, simpler, and more effective.
            </p>
          </FooterColumn>

          <FooterColumn>
            <h3>Learning Resources</h3>
            <ul>
              <li>
                <a 
                  href="#books" 
                  onClick={(e) => {
                    e.preventDefault();
                    onBooksClick && onBooksClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Books
                </a>
              </li>
              <li>
                <a 
                  href="#videos" 
                  onClick={(e) => {
                    e.preventDefault();
                    onVideoLearningClick && onVideoLearningClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Video Lessons
                </a>
              </li>
              <li>
                <a 
                  href="#academy" 
                  onClick={(e) => {
                    e.preventDefault();
                    onMkAcademyOnlineClick && onMkAcademyOnlineClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  MK Academy
                </a>
              </li>
              <li>
                <a 
                  href="#blogs" 
                  onClick={(e) => {
                    e.preventDefault();
                    onBlogsClick && onBlogsClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Blogs
                </a>
              </li>
            </ul>
          </FooterColumn>

          <FooterColumn>
            <h3>Support</h3>
            <ul>
              <li>
                <a 
                  href={`${window.location.origin}?page=contact`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ cursor: 'pointer' }}
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  href="#faq" 
                  onClick={(e) => {
                    e.preventDefault();
                    onFaqClick && onFaqClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  FAQ
                </a>
              </li>
              <li>
                <a 
                  href="#feedback" 
                  onClick={(e) => {
                    e.preventDefault();
                    onFeedbackClick && onFeedbackClick();
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Feedback
                </a>
              </li>
            </ul>
          </FooterColumn>

          <FooterColumn>
            <h3>Company</h3>
            <ul>
              <li>
                <a 
                  href="/privacy_policy.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ cursor: 'pointer' }}
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="/terms_and_conditions.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ cursor: 'pointer' }}
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </FooterColumn>
        </FooterContent>

        <FooterBottom>
          <p>&copy; 2024 MathKnots. All rights reserved.</p>
        </FooterBottom>
      </Container>
    </FooterSection>
  );
};

export default Footer; 